var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileTxt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "square",
    strokeWidth: 2,
    fill: "none",
    stroke: "#212121",
    className: "file-txt_svg__nc-icon-wrapper",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    "data-cap": "butt",
    strokeLinecap: "butt",
    d: "M20 1v8h8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 13V9l-8-8H4v12M4 27v4h24v-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 23H10v-4.4H8.6v-1.3h4.3v1.3h-1.4V23zM18.9 23h-1.8L16 21.2 14.9 23h-1.7l1.9-2.9-1.8-2.8H15l1 1.8 1-1.8h1.8L17 20.2l1.9 2.8zM22 23h-1.5v-4.4h-1.4v-1.3h4.3v1.3H22V23z",
    fill: "#212121",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 13h30v14H1z"
  }))));
}
export default SvgFileTxt;